module.exports = __webpack_public_path__ + "static/img/iconTechBoy.a35f179.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconTechBoy.svg
// module id = 0xKG
// module chunks = 1